import {ShowVerificationRequest} from './show-verification-request';

export default ShowVerificationRequest;